// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

export default {
	namespaced: true,
	state: {
		tab:{},
		// 搜索关键字
		indexDatas: {},
		cartNum: 0,
		locale:'zh-CN',
		service_fee:0,
		exchange_rate:0,
		isCn:true,
		isIframe:false,//是否框架内打开
	},
	getters: {},
	mutations: {
		setIndexData(state, data) {
			state.indexDatas = data;
		},
		setCartNum(state, data) {
			state.cartNum = data;
		},
		set_locale(state, data) {
			state.locale = data;
		},
		set_isCn(state, data) {
			state.isCn = data;
		},
		set_service_fee(state, data) {
			state.service_fee = data;
		},
		set_exchange_rate(state, data) {
			state.exchange_rate = data;
		},
		set_tab(state, data) {
			state.tab = data;
		},
		set_isIframe(state, data) {
			state.isIframe = data;
		},
	}
}
